import { Col, Input, Row } from 'antd';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const InputSearchStyled = styled(Input.Search)`
  & input {
    height: auto;
  }
`;

export const ContainerStyled = styled(Row)`
  border-radius: 10px;
  margin: 0;
  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const SearchBarContainerStyled = styled(Col)`
  margin-bottom: 0;
  width: 100%;
  max-width: 300px;
  @media screen and (max-width: ${breakpoints.sm}) {
    order: 3;
    max-width: 100%;
    width: 576px;
    margin-top: 15px;
  }
`;
